import type { TasParticipant } from './tas-participant.type.ts';
export interface TasParticipantExtension extends TasParticipant {}
export class TasParticipantExtension {
  // When a participant is "held" (aka "frozen" in product speak),
  // they are effectively barred from submitting any applications/programs.
  get isHeld() {
    return this.state === 'TAS.ParticipantState.HELD';
  }

  get isActive() {
    return this.state === 'TAS.ParticipantState.ACTIVE';
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-participant',
  features: TasParticipantExtension,
};
export default Registration;
